<template>
    <rkm-form ref="Form">
        <rkm-table
            v-for="item in data.model.itens"
            :fields="fields"
            :items="item.materiais"
            :key="item.id"
            :tbody-tr-class="rowClass"
            class="table-materiais"
            hide-filters
            hide-pagination
            ref="Table"
            sort-by="descricao"
        >
            <template #thead-top>
                <rkm-tr>
                    <rkm-th :colspan="fields.length">
                        {{ item.nome }}
                    </rkm-th>
                </rkm-tr>
            </template>

            <template v-slot:cell(subgrupo)="{ value }">
                {{ value || '-' }}
            </template>

            <template v-slot:cell(estoqueMaximo)="{ value }">
                {{ isNaN(parseInt(value)) ? '-' : value }}
            </template>

            <template v-slot:cell(permiteRequisitar)="{ value }">
                {{ isNaN(parseInt(value)) ? '-' : value }}
            </template>

            <template v-slot:cell(quantidade)="{ item }">
                <span
                    v-if="item.requisicaoQueNaoConcluiuEntrega"
                    :title="`Quantidade pendente de entrega na requisição de número ${item.requisicaoQueNaoConcluiuEntrega}`"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="info-circle" />
                </span>

                <span
                    v-else-if="item.prazoVencimento"
                    :title="`Quantidade em estoque com vencimento dentro do prazo parametrizado`"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="info-circle" />
                </span>

                <rkm-form-input
                    v-else
                    :disabled="item.permiteRequisitar === 0"
                    :validations="getQuantidadeValidations(item)"
                    class="my-auto quantidade"
                    name="Quantidade"
                    number
                    v-model="item.quantidade"
                />
            </template>

            <template #afterTable>
                <div class="my-2">
                    <p>A linha em <span class="yellow">amarelo</span> representa que o material não poderá ser requisitado, pois possui quantidade pendente de entrega em outra requisição.</p>
                    <p>A linha em <span class="red">vermelho</span> representa que o material não poderá ser requisitado, pois possui quantidade em estoque com vencimento dentro do prazo parametrizado.</p>
                </div>
            </template>
        </rkm-table>
    </rkm-form>
</template>

<script>
export default {
    computed: {
        fields() {

            return [
                {
                    key: 'codigoMaterial',
                    label: 'Código',
                    class: 'col-min',
                    sortable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                },
                {
                    key: 'subgrupo',
                    label: 'Subgrupo',
                    sortable: true,
                },
                {
                    key: 'estoque',
                    label: 'Estoque',
                    class: 'col-min text-center'
                },
                {
                    key: 'estoqueMaximo',
                    label: 'Estoque máximo',
                    class: 'col-min text-center'
                },
                {
                    key: 'permiteRequisitar',
                    label: 'Permite requisitar',
                    class: 'col-min text-center'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    class: 'col-min text-center'
                },
            ]
        },
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
        rowClass(item, type) {

            if (type === 'row' && item && item.requisicaoQueNaoConcluiuEntrega) {

                return 'table-warning'
            }

            if(type === 'row' && item && item.prazoVencimento) {

                return 'table-danger'
            }
        },
        getQuantidadeValidations(item) {

            return {
                max: 8,
                min_value: 1,
                max_value: item.estoqueMaximo !== null ? item.permiteRequisitar : 99999999,
            }
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>

<style scoped>
.table-materiais >>> .yellow { color: #e6c619; }
.table-materiais >>> .red { color: red; }
.table-materiais >>> .quantidade { min-width: 150px; }
</style>